<div class="users">
  @if (isLoading() === false) {
    <div class="users-title">
      {{ 'userManagementPage.usersPage.title' | labelsProvider }} ({{ users.length + invitations.length }})
    </div>
    <div class="users-header-actions">
      <app-search-box
        class="users-header-actions-search"
        placeholder="Search..."
        (textOnSelection)="userSearched($event)"
      >
      </app-search-box>

      <button class="users-header-actions-invite-button" (click)="inviteUserClicked()">
        <img src="assets/images/common/plus.svg" />
        {{ 'userManagementPage.usersPage.inviteUser' | labelsProvider }}
      </button>
    </div>
    <div class="users-table">
      <app-table
        [tableColumns]="usersTableCols"
        [tableRows]="tableRows"
        [isLoading]="isLoading()"
        [isScrollable]="true"
        [withCheckbox]="true"
        [withCheckboxAll]="true"
        [withDeleteIcon]="true"
        [withCopyIcon]="true"
        [withExpandFilters]="false"
        (checkboxOnClick)="onCheckboxClick($event)"
        (deleteRowOnClick)="deleteIconOnClick($event)"
        [dropDownOptions]="roleSelectOptions"
        (dropdownOnSelection)="onRoleSelected($event)"
        [allCheckedControl]="allRowsSelected"
        [checkedRowsIds]="checkedUserIds"
        [checkedRowsSupportedActions$]="multiSelectedMenuActions$"
        (multiCheckOnClick)="multiSelectedActionClick($event)"
      >
      </app-table>
    </div>
  } @else {
    <div class="users-spinner">
      <mat-progress-spinner color="primary" mode="indeterminate"> </mat-progress-spinner>
    </div>
  }
</div>
